/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     leap-form-guidance p{margin-bottom:9px;font-size:16px!important;color:#26273b!important}[nz-radio][_ngcontent-%COMP%]{display:block;margin-bottom:5px;display:flex;align-items:center}[nz-radio][_ngcontent-%COMP%]   svg[_ngcontent-%COMP%]{margin-bottom:-4px;margin-right:2px;max-height:18px;max-width:18px}form[_ngcontent-%COMP%]{display:flex;margin-top:20px}.margin-right-30[_ngcontent-%COMP%]{margin-right:30px}"];
export { styles as styles };
